export function getLogAudioBufferInfo(audioBuffer: AudioBuffer) {
  return {
    duration: audioBuffer.duration,
    sampleRate: audioBuffer.sampleRate,
    numberOfChannels: audioBuffer.numberOfChannels,
  }
}
